import React from 'react';
import { Routes, Route } from 'react-router';
import routePath from './routes';

const TermPage = React.lazy(() => import('@/pages/illustration/term'));
const CiPage = React.lazy(() => import('@/pages/illustration/ci'));
const ErrorPage = React.lazy(() => import('@/pages/error'));

export const AppRoutes = () => (
  <Routes>
    <Route path={routePath.illustration.term} element={<TermPage />} />
    <Route path={routePath.illustration.ci} element={<CiPage />} />
    <Route path={routePath.error} element={<ErrorPage />} />
  </Routes>
);
